import { useIntl } from '@/intl'
import { useResults } from '@/scopes/search/search/domain/hooks'
import { Button, Modal, SpaceBetween, tk, Typography } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'
import { ProductCardCompact } from './ProductCardCompact'

const StaticContent = styled(SpaceBetween)`
  pointer-events: none;
  .c-image-carroussel-dots {
    display: none;
  }
`

const FooterButton = styled(Button)`
  flex-basis: 50%;
`

export function LogInModal({ productId, open, onClose }: { productId: number, open: boolean, onClose: () => void }) {
  const intl = useIntl()
  const { results } = useResults()

  const product = React.useMemo(() => results.find(({ id }) => id === productId), [results, productId])

  return (
    <Modal.Root open={open} onClose={onClose}>
      <Modal.Content $size="sm">
        <Modal.Header>
          <Modal.HeaderTitle text={intl.formatMessage({ id: 'favorite_login_modal_title' })} />
          <Modal.HeaderCloseButton />
        </Modal.Header>
        <Modal.Body>
          <StaticContent
            direction="y"
            justifyContent="space-between"
            spacing={tk('spacing_xl')}
            padding={tk('spacing_xl')}
          >
            {product && (
              <ProductCardCompact
                id={product.id}
                accommodationId={product.id}
                imageSources={product.images}
                href={product.url}
                name={product.name}
                userRating={product.userRating}
                userRatingText={product.userRatingText}
                locations={product.locations}
                rating={product.rating ?? 0}
              />
            )}
            <Typography $variant="body-lg">{intl.formatMessage({ id: 'favorite_login_modal_text' })}</Typography>
          </StaticContent>
        </Modal.Body>
        <Modal.Footer>
          <FooterButton
            $hierarchy="tertiary"
            $withoutColor
            onClick={() => {
              window.location.href = `/login?returnurl=${encodeURIComponent(document.URL)}`
              onClose()
            }}
          >
            {intl.formatMessage({ id: 'favorite_login_modal_secondary_action_text' })}
          </FooterButton>
          <FooterButton
            $hierarchy="primary"
            onClick={() => {
              window.location.href = `/login?returnurl=${encodeURIComponent(document.URL)}`
              onClose()
            }}
          >
            {intl.formatMessage({ id: 'favorite_login_modal_primary_action_text' })}
          </FooterButton>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  )
}
